import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "app-preview",
    templateUrl: "./preview.component.html",
    styleUrls: ["./preview.component.scss"],
    standalone: false
})
export class PreviewDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,

    public dialogRef: MatDialogRef<PreviewDialogComponent>
  ) {
    if (data) {
      this.id = data.id;
      this.title = data.title;
      this.editable = data.editable;
      this.canvasType = data.canvasType;
    }
  }

  displayedColumns: string[] = ["name", "date", "classification"];
  dataSource: any;
  id!: number;
  title!: string;
  editable!: boolean;
  showButtons!: boolean;
  canvasType!: string;
  onNoClick(): void {
    this.dialogRef.close();
  }
  getCanvasData() {}
  ngOnInit(): void {
    this.getCanvasData();
  }
}
